module.exports = __webpack_public_path__ + "static/img/xeno-basher_256.060c0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xeno-basher_256.png
// module id = waPX
// module chunks = 0